/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_SourcesInputs */

const en_wc_vs_sources = /** @type {(inputs: Wc_Vs_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facts are from the WordCraft README and roadmap (October 2026) and Microsoft's Word product page. WordCraft changes fast, so check the official pages for the latest.`)
};

/**
* | output |
* | --- |
* | "Facts are from the WordCraft README and roadmap (October 2026) and Microsoft's Word product page. WordCraft changes fast, so check the official pages for the..." |
*
* @param {Wc_Vs_SourcesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_sources = /** @type {((inputs?: Wc_Vs_SourcesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_SourcesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_sources(inputs)
});
export { wc_vs_sources as "wc.vs.sources" }